import { Flex, Modal } from "antd";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { buildRoutePath } from "tm-shared/utils";

import { ROUTES } from "@/constants";
import {
    useAppDispatch,
    useAppSelector,
    useProtectedUserRoleSelector,
} from "@/hooks/redux";
import BaseButton from "@/shared/ui/BaseButton";
import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";
import { clearReminderModals } from "@/store/slices/ui";
import { isManagerRole } from "@/utils";

import { StyledAccentText } from "./Styled";

export interface UncompleteCheckoutsModalProps {
    onCloseModal: () => void;
}

export const UncompletedCheckoutsModal: FC<UncompleteCheckoutsModalProps> = ({
    onCloseModal,
}) => {
    const role = useProtectedUserRoleSelector();

    const { activeSchedule } = useAppSelector((state) => state.manager);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const isManager = isManagerRole(role);

    const handleConfirm = () => {
        navigate(
            isManager && !!activeSchedule?.routeId
                ? buildRoutePath(ROUTES.SVCheckoutRoute, {
                      routeId: activeSchedule.routeId,
                  })
                : ROUTES.Checkout,
        );

        dispatch(clearReminderModals());
    };

    const handleClose = () => {
        onCloseModal();
    };

    const handleIgnore = () => {
        onCloseModal();
    };

    return (
        <Modal
            open
            title=""
            onCancel={handleClose}
            centered
            footer={[]}
            mask={{ closable: false }}
        >
            <Flex vertical style={{ marginBottom: 16 }} gap={16}>
                <PrimaryText fontSize={20} fontWeight="500" textAlign="center">
                    Завершіть оформлення
                </PrimaryText>

                <SecondaryText>
                    У вашому кошику залишилися незавершені замовлення. Якщо ви
                    вносили зміни в налаштування (коментарі, інформацію про
                    дебіторку, самовивіз тощо), то після очищення кешу ці зміни
                    можуть зникнути. Самі замовлення при цьому залишаться
                    збереженими.
                </SecondaryText>

                <SecondaryText>
                    Будь ласка, за потреби перейдіть на сторінку{" "}
                    <StyledAccentText>Кошик</StyledAccentText>, щоб завершити
                    оформлення.
                </SecondaryText>
            </Flex>

            <Flex vertical gap={8}>
                <BaseButton
                    bgColor="success"
                    type="primary"
                    onClick={handleConfirm}
                >
                    Перейти в Кошик
                </BaseButton>

                <BaseButton type="default" onClick={handleIgnore}>
                    Ігнорувати
                </BaseButton>
            </Flex>
        </Modal>
    );
};
